import { object, string, number, date, boolean } from 'yup';
import { AUDIT_TYPES, AUDIT_STATUSES } from './audit.constants';

const auditSchema = object({
  id: string(),
  company_id: string().nullable(),
  created_on: date().required(),
  updated_on: date().required(),
  deal_id: string().nullable().default(null),
  listedkit_id: string().nullable().default(null),
  name: string().required(),
  type: string().oneOf(Object.values(AUDIT_TYPES)).required(),
  status: string().oneOf(Object.values(AUDIT_STATUSES)).required(),
  due_in_days: number().integer().required(),
  is_after_action: boolean().required().default(false),
  due_relative_date: string().required(),
});

export default auditSchema;
